import { render } from "./OcrSidebarSkeleton.vue?vue&type=template&id=aae0e03e"
import script from "./OcrSidebarSkeleton.vue?vue&type=script&lang=js"
export * from "./OcrSidebarSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__